/*
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-03-31 11:03:58
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-06 13:44:01
 * @FilePath: /vue3-template-web/src/util/storeModules/system-login.js
 * @Description: 系统登录
 */
import { get, post } from '@/util/http.js'
import { ElMessage } from 'element-plus'
export default {
  state: {
    form: {
      account: '',
      password: '',
      code: ''
    },
    base64: '',
    rules: {
      account: [
        { required: true, message: '请输入账号', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
      ],
      code: [
        { required: true, message: '请输入验证码', trigger: 'blur' }
      ]
    },
    userInfo: {}
  },
  mutations: {
    setUserInfo (state, payload) {
      state.userInfo = payload
    }
  },
  actions: {
    // 获取验证码
    async getCode ({ state }) {
      try {
        const { data } = await get({ url: '/ImgCheck' })
        state.base64 = data
      } catch (error) {
        console.log(error)
      }
    },
    // 登录
    async login ({ state, dispatch }) {
      try {
        const { account, password, code: validCode } = state.form
        const { code, data, message } = await post({ url: '/Login', params: { ryzh: account, zhmm: password, code: validCode } })
        if (code === 1) {
          state.userInfo = data
          state.bottomBanner = true
          state.form = {
            account: '',
            password: '',
            code: ''
          }
          // 前往首页
          location.hash = '#/'
        } else {
          state.form.code = ''
          dispatch('getCode')
          ElMessage({
            message: message,
            type: 'error'
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 登出
    async logout () {
      try {
        const { code, message } = await get({ url: '/Logout' })
        if (code === 1) {
          location.hash = '#/system-login'
        } else {
          ElMessage({
            message: message,
            type: 'error'
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
